export enum HistoryAction {
    SetNodeVisible
}
